/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

import { ZoomClient } from '@/index-types';

function useAutoPlayAudioFailed(zoomClient: ZoomClient, onFailed: () => void) {
  useEffect(() => {
    const handleMediaFailed = (payload: any) => {
      console.log('auto-play-audio-failed', payload);
      onFailed();
    };
    zoomClient.on('auto-play-audio-failed', handleMediaFailed);
    return () => {
      zoomClient.off('auto-play-audio-failed', handleMediaFailed);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoomClient]);
}

export default useAutoPlayAudioFailed;
